@if (sections.length > 0) {
  @for (section of sections; track section.level) {
    <div class="tooltip-section">
      <div class="tooltip-level">{{ getTitleByLevel(section.level) }}</div>
      <div class="tooltip-section-table">
        <table class="tooltip-table table-borderless">
          <tbody>
            @for (row of section.rows; track $index) {
              <tr>
                @if (showTimestamp) {
                  <td class="tooltip-value">{{ getNiceDate(row.value) }}</td>
                }
                <td class="tooltip-tag">{{ row.tag }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
} @else {
  <div class="tooltip-empty">No tooltip data</div>
}
